<script lang="ts">
	import { format } from 'svelte-i18n';
	import { is_enable_disable_scene_action_ui, is_play_scene_action_ui } from 'src/types/SceneActionUI';
	import { rooms } from 'src/stores/lists/rooms';
	import { scenes } from 'src/stores/lists/scenes';
	import { navigateToShop, sortByPosition } from 'src/components/Lists/list-helpers';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { DO_WIZARD_STEPS_INDEXES } from '../../helpers/do-wizard-helpers';
	import { _deepClone, _deepCopyArr, capFirstChar } from 'src/helpers/utilities';
	import EmptyList from 'src/components/Lists/EmptyList.svelte';

	export let sceneData: any;
	export let firstSelectedRef: HTMLElement = null;

	if (
		is_play_scene_action_ui(sceneData.translated) ||
		is_enable_disable_scene_action_ui(sceneData.translated)
	) {
		sceneData.selectedScene = {
			id: $scenes[sceneData.translated?.scene_id]?.id,
			name: $scenes[sceneData.translated?.scene_id]?._meta?.name || 'Unknown scene',
		};

		if (sceneData.translated.delay !== undefined) {
			sceneData.alarmAction.delay = { ...sceneData.translated.delay };
		}
	}

	const validateWizardStepSelectScene = () => {
		sceneData.isValid = false;
		sceneData.validStepIndex = DO_WIZARD_STEPS_INDEXES.ALARM_AS;
		sceneData = _deepClone({
			...sceneData,
			alarmAction: {
				option: undefined,
				delay: {
					value: 0,
					units: 'sec',
				},
			},
		});
	};

	const onSelectScene = (e) => {
		validateWizardStepSelectScene();
		sceneData.selectedScene = e.detail;
	};

	const getScenesByRoomID = (roomID) => {
		return Object.values($scenes)
			.sort(sortByPosition)
			.filter((sc: any) => {
				//if scene is an alarm
				if (sc._gui_function === 'alarm') {
					return Number(roomID) === -1
						? sc._meta.room == roomID || sc._meta.room === ''
						: sc._meta.room == roomID;
				}
			})
			.map((el: any) => {
				return {
					name: el._meta.name,
					image: el._meta.image,
					icon: el._meta.icon,
					id: el._id,
					...el,
				};
			});
	};

	const mapRoomGroupSelectedProp = (room, sceneSelected) => {
		const updatedCards = room.cards.map((scene) => {
			if (scene.id === sceneSelected?.id) {
				return {
					...scene,
					selected: true,
				};
			}
			return {
				...scene,
				selected: false,
			};
		});

		return {
			...room,
			cards: updatedCards,
		};
	};

	$: sortedRoomsWithScenes = [
		{ id: -1, name: 'Global', position: -1 } as any,
		...Object.values($rooms),
	]
		.sort(sortByPosition)
		.map((room: any) => {
			return {
				cards: getScenesByRoomID(room.id),
				roomID: room.id,
				roomName: room.name,
			};
		})
		.filter((room) => {
			return room.cards.length > 0;
		})
		.map((room) => {
			return mapRoomGroupSelectedProp(room, sceneData.selectedScene);
		});
</script>

<SelectList
	class="mb-s"
	title={$format('label_select_alarm', {
		default: 'Select alarm',
	})}
	list={sortedRoomsWithScenes}
	variant="radio"
	selectedCardsId={[sceneData.selectedScene]}
	on:click={(e) => onSelectScene(e)}
	bind:firstSelectedRef
/>

{#if !sortedRoomsWithScenes.length}
	<div class="d-flex flex-direction-column justify-content-center align-items-center mt-s">
		<EmptyList
			withoutMargin
			type="modal"
			title={$format('on_board_get_device_title', {
				default: 'Get the necessary devices to set up.',
			})}
			description={$format('on_board_get_device_description', {
				default:
					'Currently you don’t have the necessary devices. Please get the necessary devices to set up your automations.',
			})}
			btnText={capFirstChar(
				$format('button_go_to_store', {
					default: 'Go to store',
				}).toLocaleLowerCase(),
			)}
			onClick={() => {
				navigateToShop();
			}}
		/>
	</div>
{/if}
